import {
  GretaAIChat,
  GretaAIChatContext,
  useGretaAIChatSession,
} from '../../../GretaAIChat'
import { GretaAIActionButton } from '../GretaAIActionButton'

function LayoutOverlayGretaAIChat({ displayName }) {
  const gretaAIChat = useGretaAIChatSession({ displayName })

  const { hasUnread, isFinanceUnread, isLocked, launcherRef, tooltip, onOpen } =
    gretaAIChat.launcher

  return (
    <>
      <GretaAIActionButton
        elementRef={launcherRef}
        hasUnread={hasUnread}
        isFinanceUnread={isFinanceUnread}
        isLocked={isLocked}
        tooltip={tooltip}
        onClick={onOpen}
      />
      <GretaAIChatContext value={gretaAIChat}>
        <GretaAIChat />
      </GretaAIChatContext>
    </>
  )
}

export default LayoutOverlayGretaAIChat
